import { Form, FormSelect } from 'react-bootstrap';
import { useEffect, useState } from 'react';

export const Select = ({ label = '', initialValue = '', onChange, options = [], ...props }) => {
  const [value, setValue] = useState();

  const handleSelect = (e) => {
    onChange(e);
    setValue(e.target.value);
  };

  useEffect(() => {
    if (initialValue !== undefined) setValue(initialValue);
  }, [initialValue]);

  // useEffect(() => {
  //     if (initialValue) {
  //         const selectedItem = options.findIndex((i) => i.value === initialValue)
  //         const newData = [...options];
  //         [newData[0], newData[selectedItem]] = [newData[selectedItem], newData[0]];
  //         setData(newData)
  //     } else {
  //         setData(options)
  //     }
  // }, [options]);

  // if (!data) return;

  return (
    <Form.Group className={`mb-3`}>
      {label && <Form.Label>{label}</Form.Label>}
      <Form.Select onChange={handleSelect} value={value} {...props}>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );
};
